<template>
    <div class="ht-tab-wrap">
      <div class="section-title-wrapper text-center section-space--mb_30">
        <h5 class="section-title font-width-light wow move-up">Les douleurs</h5>
      </div>
        <b-tabs class="ht-tab-menu wow move-up">
            <b-tab title="Névrome de Morton" active>
                <!-- tab content one component -->
                <DouleurNevromeDeMorton />
            </b-tab>
            <b-tab title="Hallux Abducto Valgus">
                <!-- tab content two component -->
                <DouleurHalluxAbducto />
            </b-tab>
            <b-tab title="Fasciite plantaire">
                <!-- tab content third component -->
              <DouleurFasciitePlantaire />
            </b-tab>
            <b-tab title="Orteils marteaux">
              <!-- tab content two component -->
              <DouleurOrteilsMarteaux />
            </b-tab>
            <b-tab title="Pieds plats">
              <!-- tab content one component -->
              <DouleurPiedsPlats />
            </b-tab>
            <b-tab title="Arthrose">
              <!-- tab content two component -->
              <DouleurArthrose />
            </b-tab>
            <b-tab title="Tendinite">
              <!-- tab content two component -->
              <DouleurTendinite />
            </b-tab>
            <b-tab title="Traumas">
              <!-- tab content two component -->
              <DouleurTraumas />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import DouleurNevromeDeMorton from '@/components/pied-pro-custom/soins/douleurs/DouleurNevromeDeMorton'
    import DouleurHalluxAbducto from '@/components/pied-pro-custom/soins/douleurs/DouleurHalluxAbducto'
    import DouleurFasciitePlantaire from '@/components/pied-pro-custom/soins/douleurs/DouleurFasciitePlantaire'
    import DouleurOrteilsMarteaux from '@/components/pied-pro-custom/soins/douleurs/DouleurOrteilsMarteaux'
    import DouleurPiedsPlats from '@/components/pied-pro-custom/soins/douleurs/DouleurPiedsPlats'
    import DouleurArthrose from '@/components/pied-pro-custom/soins/douleurs/DouleurArthrose'
    import DouleurTendinite from '@/components/pied-pro-custom/soins/douleurs/DouleurTendinite'
    import DouleurTraumas from '@/components/pied-pro-custom/soins/douleurs/DouleurTraumas'

    export default {
        name: 'DouleurContainer',
        components: {
            DouleurNevromeDeMorton,
            DouleurHalluxAbducto,
            DouleurFasciitePlantaire,
            DouleurOrteilsMarteaux,
            DouleurPiedsPlats,
            DouleurArthrose,
            DouleurTendinite,
            DouleurTraumas
        }
    };
</script>